import Text from 'components/Text/Text';
import React from 'react';
import style from './SelectDropdownReloader.module.scss';
import breadcrumbs from 'assets/img/breadcrumbs.svg';

interface ISelectDropdownReloader {
	onReload: () => void;
}

const SelectDropdownReloader: React.FC<ISelectDropdownReloader> = ({ onReload }) => {
	return (
		<div className={style.container} data-test="SelectDropdownReloader">
			<Text
				className={style.title}
				translationNameSpace="listing"
				translationKey="tryAgainText"
				theme="secondary"
				weight="bold"
				align="center"
			/>
			<div className={style.reloadBtn} onClick={onReload}>
				<svg>
					<use xlinkHref={`${breadcrumbs}#reload`} />
				</svg>
				<Text translationNameSpace="listing" translationKey="tryAgainButton" asFragment={true} />
			</div>
		</div>
	);
};

export default SelectDropdownReloader;
